module.exports = __webpack_public_path__ + "static/media/ear-muffs.2f3f15b1.svg";